import React from "react";
import SummaryWrapper from "../../../../IpEMR/InspectionSummaries/SummaryWrapper";
import { checkEmpty } from "../../../../../helpers/utility";
import {
  activePassiveOptions,
  cardioCongenitalOptions,
  cardioPastMedicalOptions,
  opExaminationOptions,
  orthoChiefComplaintOptions,
  orthoHistoryOptions,
  habitOptions,
} from "../OpPhysioOptions";
import {
  getLabel,
  getLabelScalesTags,
  getLabelTag,
  getLabelTagInput,
  getLabelTagsArray,
  getLabelTagsWithDescription,
  getLabelTagsWithDynamicInputs,
  getLabelTagYesNO,
  getTherapyLabelTags,
} from "../../../../IpEMR/InspectionSummaries/constructTextFromValues";
import {
  alcoholOptions,
  smokingOptions,
} from "../../../../IpEMR/Options/historyOptions";
import {
  mmtScaleOptions,
  orthoDiagnosisOptions,
  orthoTherapyOptions,
} from "../../../../IpEMR/Options/physioOptions";
import { getExerciseSummary } from "../../../../IpEMR/InspectionSummaries/constructTextFromValues";
import { barthelIndexOptions } from "../../../../IpEMR/Options/functionalAsessmentOptions";
import {
  ankleOptions,
  cervicalOptions,
  elbowOptions,
  hipOptions,
  kneeOptions,
  lumbarOptions,
  sacroiliacOptions,
  shoulderOptions,
  thoracicOptions,
  tnjOptions,
  wristAndHandOptions,
} from "./orthoOptions";

const OrthoSummary = ({ formData }) => {
  const constructOrthoSummaryItems = () => {
    const getRomSummary = (list, data) => {
      const enteredOptions = list.reduce((acc, item) => {
        const filtered = Object.entries(data).filter(([key, value]) =>
          key.endsWith(item)
        );
        return [...acc, ...filtered];
      }, []);

      return enteredOptions?.length === 0
        ? null
        : enteredOptions?.map(([key, value]) => {
            const node = getLabelTagInput(
              key
                .split("_")
                .map(
                  (word) =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join(" "),
              value
            );
            return node ? React.cloneElement(node, { key }) : null;
          });
    };
    const orthoSummaryItems = [];
    const pushSummaryItem = (key, label, children) => {
      orthoSummaryItems.push({ key, label, children });
    };

    if (checkEmpty(formData?.chief_complaint)) {
      pushSummaryItem(
        "1",
        "Chief Complaints",
        <>
          {getLabelTagsArray(
            orthoChiefComplaintOptions,
            formData?.chief_complaint?.chief_complaints
          )}
          {getLabelTagInput("Comments", formData?.chief_complaint?.comments)}
        </>
      );
    }

    if (checkEmpty(formData?.history)) {
      const pastMedicalHistoryValues = formData?.history?.past_medical_history;
      const showPastMedicalOthersRemarks =
        Array.isArray(pastMedicalHistoryValues) &&
        pastMedicalHistoryValues.includes("past_medical_others");

      const congenitalDisordersValues = formData?.history?.congenital_disorders;
      const showCongenitalOtherRemarks =
        Array.isArray(congenitalDisordersValues) &&
        congenitalDisordersValues.includes("cardio_congenital_options");

      pushSummaryItem(
        "2",
        "History",
        <>
          {checkEmpty(formData?.history?.history) &&
            getLabelTagInput(
              "History",
              getLabelTagsArray(orthoHistoryOptions, formData?.history?.history)
            )}

          {(checkEmpty(pastMedicalHistoryValues) ||
            (showPastMedicalOthersRemarks &&
              checkEmpty(formData?.history?.past_medical_comments))) &&
            getLabelTagInput(
              "Past Medical History",
              <>
                {getLabelTagsArray(
                  cardioPastMedicalOptions,
                  pastMedicalHistoryValues
                )}
                {showPastMedicalOthersRemarks &&
                  formData?.history?.past_medical_comments &&
                  formData.history.past_medical_comments
                    .map((item, idx) => {
                      const node = getLabelTagInput(
                        `Remarks ${idx + 1}`,
                        item.remarks
                      );
                      const k = item?.id ?? item?.remarks ?? idx;
                      return node ? React.cloneElement(node, { key: k }) : null;
                    })
                    .filter(Boolean)}
              </>
            )}
          {(checkEmpty(congenitalDisordersValues) ||
            checkEmpty(formData?.history?.congenital_disorders_comments) ||
            (showCongenitalOtherRemarks &&
              checkEmpty(formData?.history?.congenital_disorders_other))) &&
            getLabelTagInput(
              "Congenital Disorders",
              <>
                {getLabelTagsArray(
                  cardioCongenitalOptions,
                  congenitalDisordersValues
                )}

                {showCongenitalOtherRemarks &&
                  Array.isArray(formData?.history?.congenital_disorders_other) &&
                  formData.history.congenital_disorders_other
                    .map((item, idx) => {
                      const node = getLabelTagInput(
                        `Remarks ${idx + 1}`,
                        item.remarks
                      );
                      const k = item?.id ?? item?.remarks ?? idx;
                      return node ? React.cloneElement(node, { key: k }) : null;
                    })
                    .filter(Boolean)}

                {formData?.history?.congenital_disorders_comments &&
                  getLabelTagInput(
                    "Comments",
                    formData?.history?.congenital_disorders_comments
                  )}
              </>
            )}
          {formData?.history?.past_surgical_history &&
            getLabelTagInput(
              "Past Surgical History",
              <>
                {formData.history.past_surgical_history === "yes"
                  ? "Yes"
                  : "No"}
                {(formData?.history?.past_surgical_comments ||
                  formData?.history?.past_surgical_history_comments) &&
                  getLabelTagInput(
                    "Comments",
                    formData?.history?.past_surgical_comments ??
                      formData?.history?.past_surgical_history_comments
                  )}
              </>
            )}

          {formData?.history?.smoking &&
            getLabelTagInput(
              "Smoking",
              getLabelTag(smokingOptions, formData?.history?.smoking)
            )}

          {formData?.history?.alcohol &&
            getLabelTagInput(
              "Alcohol",
              getLabelTag(alcoholOptions, formData?.history?.alcohol)
            )}

          {formData?.history?.life_style &&
            getLabelTagInput(
              "Life Style",
              getLabelTag(habitOptions, formData?.history?.life_style)
            )}
          {formData?.history?.habits_comments &&
            getLabelTagInput("Comments", formData?.history?.habits_comments)}
        </>
      );
    }

    if (checkEmpty(formData?.examination)) {
      pushSummaryItem(
        "3",
        "Examination",
        <>
          {getLabelTagsWithDescription(
            opExaminationOptions,
            formData?.examination
          )}
          {getLabelTagInput("Pain level", formData?.examination?.pain)}
          {getLabelTagInput(
            "Interpretation",
            formData?.examination?.pain_interpretation
          )}
          {getLabelTagInput(
            "Comments",
            formData?.examination?.examination_comments
          )}
        </>
      );
    }

    if (checkEmpty(formData?.mmt)) {
      pushSummaryItem(
        "4",
        "MMT",
        <>
          {getLabelTagInput(
            "Left Upper Limb",
            getLabelTag(mmtScaleOptions, formData?.mmt?.upper_left_limb)
          )}
          {getLabelTagInput(
            "Right Upper Limb",
            getLabelTag(mmtScaleOptions, formData?.mmt?.upper_right_limb)
          )}
          {getLabelTagInput(
            "Left Lower Limb",
            getLabelTag(mmtScaleOptions, formData?.mmt?.lower_left_limb)
          )}
          {getLabelTagInput(
            "Right Lower Limb",
            getLabelTag(mmtScaleOptions, formData?.mmt?.lower_right_limb)
          )}
          {formData?.mmt?.comments &&
            getLabelTagInput("Comments", formData?.mmt?.comments)}
        </>
      );
    }

    if (checkEmpty(formData?.finger_grip_test)) {
      pushSummaryItem(
        "5",
        "Finger Grip Test",
        <>
          {getLabelTagInput("Age", formData?.finger_grip_test?.age)}
          {getLabelTagInput(
            "Left Hand Grip Strength",
            formData?.finger_grip_test?.left_hand
          )}
          {getLabelTagInput(
            "Left Hand Grip Interpretation",
            formData?.finger_grip_test?.left_hand_interpretation
          )}

          {getLabelTagInput(
            "Right Hand Grip Strength",
            formData?.finger_grip_test?.right_hand
          )}
          {getLabelTagInput(
            "Right Hand Grip Interpretation",
            formData?.finger_grip_test?.right_hand_interpretation
          )}
          {formData?.finger_grip_test.comments &&
            getLabelTagInput("Comments", formData?.finger_grip_test?.comments)}
        </>
      );
    }

    if (checkEmpty(formData?.rom)) {
      pushSummaryItem(
        "6",
        "ROM",
        <>
          {formData?.rom?.shoulder_joint &&
            getLabelTagInput(
              "Shoulder Joint",
              getRomSummary(
                [
                  "flexion",
                  "extension",
                  "abduction",
                  "adduction",
                  "medial_rotation",
                  "lateral_rotation",
                ],
                formData?.rom?.shoulder_joint
              )
            )}
          {formData?.rom?.elbow_joint &&
            getLabelTagInput(
              "Elbow Joint",
              getRomSummary(
                ["flexion", "extension"],
                formData?.rom?.elbow_joint
              )
            )}
          {formData?.rom?.forearm_joint &&
            getLabelTagInput(
              "Forearm Joint",
              getRomSummary(
                ["supination", "pronation"],
                formData?.rom?.forearm_joint
              )
            )}
          {formData?.rom?.wrist_joint &&
            getLabelTagInput(
              "Wrist Joint",
              getRomSummary(
                ["flexion", "extension", "radial_deviation", "ulnar_deviation"],
                formData?.rom?.wrist_joint
              )
            )}
          {formData?.rom?.thumb_joint &&
            getLabelTagInput(
              "Thumb Joint",
              getRomSummary(
                ["cmc_flexion", "cmc_extension", "cmc_abduction", "ip_flexion"],
                formData?.rom?.thumb_joint
              )
            )}
          {formData?.rom?.metacarpel_joint &&
            getLabelTagInput(
              "MetaCarpel Joint",
              getRomSummary(
                ["flexion", "hyperextension", "abduction"],
                formData?.rom?.metacarpel_joint
              )
            )}
          {formData?.rom?.proximal_joint &&
            getLabelTagInput(
              "Proximal Interphalangeal Joint",
              getRomSummary(
                ["flexion", "extension"],
                formData?.rom?.proximal_joint
              )
            )}
          {formData?.rom?.disital_joint &&
            getLabelTagInput(
              "Distal Interphalangeal Joint",
              getRomSummary(
                ["flexion", "extension"],
                formData?.rom?.disital_joint
              )
            )}
          {formData?.rom?.hip_joint &&
            getLabelTagInput(
              "Hip Joint",
              getRomSummary(
                [
                  "flexion",
                  "extension",
                  "abduction",
                  "adduction",
                  "medial_rotation",
                  "lateral_rotation",
                ],
                formData?.rom?.hip_joint
              )
            )}
          {formData?.rom?.knee_joint &&
            getLabelTagInput(
              "Knee Joint",
              getRomSummary(["flexion", "extension"], formData?.rom?.knee_joint)
            )}
          {formData?.rom?.ankle_joint &&
            getLabelTagInput(
              "Ankle Joint",
              getRomSummary(
                ["dorsiflexion", "plantarflexion"],
                formData?.rom?.ankle_joint
              )
            )}
          {formData?.rom?.foot_joint &&
            getLabelTagInput(
              "Foot Joint",
              getRomSummary(
                ["inversion", "eversion"],
                formData?.rom?.foot_joint
              )
            )}
          {formData?.rom?.great_toe_joint &&
            getLabelTagInput(
              "Great Toe Joint",
              getRomSummary(
                ["flexion", "extension"],
                formData?.rom?.great_toe_joint
              )
            )}
          {formData?.rom?.inter_phalangeal_joint &&
            getLabelTagInput(
              "Inter Phalangeal Joint",
              getRomSummary(
                ["flexion", "extension"],
                formData?.rom?.inter_phalangeal_joint
              )
            )}
          {formData?.rom?.cervical_spine &&
            getLabelTagInput(
              "Cervical Spine",
              getRomSummary(
                [
                  "flexion",
                  "extension",
                  "right_rotation",
                  "left_rotation",
                  "right_lateral_rotation",
                  "left_lateral_rotation",
                ],
                formData?.rom?.cervical_spine
              )
            )}
          {formData?.rom?.thoraco_lumbar_spine &&
            getLabelTagInput(
              "Thoraco Lumbar Spine",
              getRomSummary(
                [
                  "flexion",
                  "extension",
                  "right_rotation",
                  "left_rotation",
                  "right_lateral_rotation",
                  "left_lateral_rotation",
                ],
                formData?.rom?.thoraco_lumbar_spine
              )
            )}
          {formData?.rom?.comments &&
            getLabelTagInput("Comments", formData?.rom?.comments)}
        </>
      );
    }

    if (checkEmpty(formData?.coordination)) {
      pushSummaryItem(
        "7",
        "Coordination",
        <>
          {getLabelTagInput(
            "Finger-to-Nose Test",
            formData?.coordination?.finger_to_nose
          )}
          {getLabelTagInput(
            "Finger-to-Finger Test",
            formData?.coordination?.finger_to_finger
          )}
          {getLabelTagInput(
            "Adiadokokinesia or Dysdiadokokinesia",
            formData?.coordination?.adiadochokinesia_or_dysdiadokokinesia
          )}
          {getLabelTagInput(
            "Rebound Phenomena",
            formData?.coordination?.rebound_phenomenon
          )}
          {getLabelTagInput(
            "Walking Along a Straight Line",
            formData?.coordination?.walking_along_straight_line
          )}
          {getLabelTagInput(
            "Romberg's Test",
            formData?.coordination?.rombergs_test
          )}
          {getLabelTagInput(
            "Heel on Shin Test",
            formData?.coordination?.heel_to_shin ??
              formData?.coordination?.heel_on_shin
          )}
          {formData?.coordination?.comments &&
            getLabelTagInput("Comments", formData?.coordination?.comments)}
        </>
      );
    }

    if (checkEmpty(formData?.tcms)) {
      pushSummaryItem(
        "8",
        "TCMS",
        <>
          {getLabelTagInput("Score", formData?.tcms?.score)}
          {getLabelTagInput("Interpretation", formData?.tcms?.interpretation)}
          {getLabelTagInput(
            "Static Sitting Balance",
            formData?.tcms?.sitting_balance
          )}
          {getLabelTagInput(
            "Selective Movement Control",
            formData?.tcms?.selective_movement_control
          )}
          {getLabelTagInput(
            "Dynamic Reaching",
            formData?.tcms?.sitting_to_standing
          )}
          {formData?.tcms?.comments &&
            getLabelTagInput("Comments", formData?.tcms?.comments)}
        </>
      );
    }

    const barthelData = formData?.barthel_index || formData?.barthel;
    if (checkEmpty(barthelData)) {
      pushSummaryItem(
        "9",
        "Barthel Index",
        <>
          {getLabelTagInput("Score", barthelData?.score)}
          {getLabelTagInput("Interpretation", barthelData?.interpretation)}
          {getLabelScalesTags(barthelIndexOptions, barthelData)}
          {barthelData?.comments &&
            getLabelTagInput("Comments", barthelData?.comments)}
        </>
      );
    }
    const renderSpecialTestsForJoint = (jointName, options, displayName) => {
      const jointData = formData?.special_tests?.[jointName];
      if (!jointData) return null;

      const elements = [];

      if (jointData.left && Object.keys(jointData.left).length > 0) {
        const leftContent = getLabelScalesTags(options, jointData.left);
        if (leftContent && leftContent.length > 0) {
          elements.push(getLabelTagInput(`${displayName} - Left`, leftContent));
        }
      }

      if (jointData.right && Object.keys(jointData.right).length > 0) {
        const rightContent = getLabelScalesTags(options, jointData.right);
        if (rightContent && rightContent.length > 0) {
          elements.push(
            getLabelTagInput(`${displayName} - Right`, rightContent)
          );
        }
      }

      if (elements.length === 0) return null;
      return <>{elements}</>;
    };

    if (formData?.special_tests) {
      const specialTestsContent = (
        <>
          {renderSpecialTestsForJoint(
            "shoulder_special_tests",
            shoulderOptions,
            "Shoulder"
          )}
          {renderSpecialTestsForJoint(
            "elbow_special_tests",
            elbowOptions,
            "Elbow"
          )}
          {renderSpecialTestsForJoint(
            "wrist_hand_special_tests",
            wristAndHandOptions,
            "Wrist & Hand"
          )}
          {renderSpecialTestsForJoint("hip_special_tests", hipOptions, "Hip")}
          {renderSpecialTestsForJoint(
            "knee_special_tests",
            kneeOptions,
            "Knee"
          )}
          {renderSpecialTestsForJoint(
            "ankle_foot_special_tests",
            ankleOptions,
            "Ankle & Foot"
          )}
          {renderSpecialTestsForJoint(
            "cervical_special_tests",
            cervicalOptions,
            "Cervical Spine"
          )}
          {renderSpecialTestsForJoint(
            "thoracic_special_tests",
            thoracicOptions,
            "Thoracic Spine"
          )}
          {renderSpecialTestsForJoint(
            "lumbar_special_tests",
            lumbarOptions,
            "Lumbar Spine"
          )}
          {renderSpecialTestsForJoint(
            "sacroiliac_joint_special_tests",
            sacroiliacOptions,
            "Sacroiliac Joint"
          )}
          {renderSpecialTestsForJoint("tmj_special_tests", tnjOptions, "TMJ")}
        </>
      );

      if (specialTestsContent.props.children.some((child) => child !== null)) {
        pushSummaryItem("10", "Special Tests", specialTestsContent);
      }
    }

    if (checkEmpty(formData?.functional_diagnosis)) {
      const functionalDiagnosisValues = formData?.functional_diagnosis?.diagnosis;
      const showFunctionalDiagnosisOthers =
        Array.isArray(functionalDiagnosisValues) &&
        functionalDiagnosisValues.includes("others");
      pushSummaryItem(
        "11",
        "Functional Diagnosis",
        <>
          {getLabelTagsArray(
            orthoDiagnosisOptions,
            functionalDiagnosisValues
          )}
          {showFunctionalDiagnosisOthers &&
            getLabelTagsWithDynamicInputs(
              formData?.functional_diagnosis?.diagnosis_others
            )}
          {getLabelTagInput(
            "Comments",
            formData?.functional_diagnosis?.diagnosis_comments
          )}
        </>
      );
    }

    if (checkEmpty(formData?.therapy)) {
      pushSummaryItem(
        "12",
        "Therapy",
        <>
          {getTherapyLabelTags(orthoTherapyOptions, formData?.therapy)}
          {getLabelTagInput(
            "Others",
            getLabelTagsWithDynamicInputs(formData?.therapy?.others)
          )}
          {getLabelTagInput(
            "Postural Correction",
            formData?.therapy?.postural_correction
          )}
          {getLabelTagInput("Comments", formData?.therapy?.therapy_comments)}
        </>
      );
    }
    const exerciseList = Array.isArray(formData?.exercise)
      ? formData.exercise
      : Object.values(formData?.exercise || {});

    if (exerciseList.length > 0) {
      pushSummaryItem("13", "Exercise", getExerciseSummary(exerciseList));
    }

    if (checkEmpty(formData?.review_notes)) {
      pushSummaryItem(
        "14",
        "Review Notes",
        <>
          {getLabelTagInput(
            "Progress Notes",
            formData?.review_notes?.progress_notes
          )}
          {getLabelTagInput(
            "Review Notes",
            formData?.review_notes?.review_notes
          )}
        </>
      );
    }
    return orthoSummaryItems;
  };

  const orthoSummaryItems = constructOrthoSummaryItems();
  return <SummaryWrapper items={orthoSummaryItems} />;
};

export default OrthoSummary;
